import {
  CapaBankCode,
  CapaErrorCode,
  useCreateMyRefundAccountByQuotationUserMutation
} from '@generated/graphql';

interface RegistRefundAccountArgs {
  account: string;
  bankCode: CapaBankCode;
  onValidateError: () => void;
}

const useRegistRefundAccount = () => {
  const [
    createMyRefundAccountByQuotationUser
  ] = useCreateMyRefundAccountByQuotationUserMutation({
    refetchQueries: ['fetchMyQuotationUser']
  });

  const registRefundAccount = async ({
    account,
    bankCode,
    onValidateError
  }: RegistRefundAccountArgs) => {
    const response = await createMyRefundAccountByQuotationUser({
      variables: {
        input: {
          account,
          bankCode
        }
      }
    });

    const result = response.data?.createMyRefundAccountByQuotationUser?.result;
    const isSuccess = result === CapaErrorCode.Success;

    if (!isSuccess) {
      switch (result) {
        case CapaErrorCode.InvalidAccount:
        case CapaErrorCode.AccountHolderMismatch: {
          onValidateError();
          throw new Error('등록할 환불계좌정보를 다시 확인해주세요.');
        }

        default:
          throw new Error('환불계좌 등록에 실패했습니다. 다시 시도해주세요.');
      }
    }
  };

  return registRefundAccount;
};

export default useRegistRefundAccount;
